import { render, staticRenderFns } from "./roster-upload.vue?vue&type=template&id=31291f53&scoped=true&"
import script from "./roster-upload.ts?vue&type=script&lang=ts&"
export * from "./roster-upload.ts?vue&type=script&lang=ts&"
import style0 from "./roster-upload.scss?vue&type=style&index=0&id=31291f53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31291f53",
  null
  
)

export default component.exports